import { matchTrackerApi } from '../../modules/servers/api'
import { SessionUploadStatus } from './types'

export const uploadStatusApi = matchTrackerApi.injectEndpoints({
  endpoints: (builder) => ({
    getStatusForSession: builder.query<SessionUploadStatus, string>({
      query: (sessionId) => ({
        url: `/upload/${sessionId}/status`,
        method: 'GET'
      }),
      providesTags: ['uploadStatus']
    }),
    getAllStatus: builder.query<SessionUploadStatus[], void>({
      query: () => ({
        url: '/upload/status',
        method: 'GET'
      }),
      providesTags: ['uploadStatus']
    }),
    retrySession: builder.mutation<void, string>({
      query: (sessionId) => ({
        url: `/upload/${sessionId}/retry`,
        method: 'POST'
      }),
      invalidatesTags: ['uploadStatus']
    })
  })
})

export const {
  useGetStatusForSessionQuery,
  useGetAllStatusQuery,
  useRetrySessionMutation
} = uploadStatusApi
